import {
    getModule,
    Module,
    Mutation,
    Action,
    VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import {SearchResult} from '@/store/models';
import * as api from '../api';

@Module({
    namespaced: true,
    name: 'search',
    store,
    dynamic: true,
})
class SeachModule extends VuexModule {
    pending: boolean = false;
    result: SearchResult | null = null;

    @Action
    async search(term: string) {
        this.setPending(true);
        if (term) {
            this.setResult(await api.searchCompanies(term));
        }
        this.setPending(false);
    }

    @Mutation
    setPending(pending: boolean) {
        this.pending = pending;
    }

    @Mutation
    setResult(result: SearchResult | null) {
        this.result = result;
    }

}

export default getModule(SeachModule);
